import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteGroupe } from '../api/GROUPES/groupes';
import { toast } from 'react-toastify';

export const useDeleteGroupe = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteGroupe,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['groupes'] });
            toast.success('Groupe supprimé avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la suppression du groupe');
        },
    });
};
